import { render, staticRenderFns } from "./PylonSignage.vue?vue&type=template&id=84a43e4e&scoped=true&"
import script from "./PylonSignage.vue?vue&type=script&lang=ts&"
export * from "./PylonSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a43e4e",
  null
  
)

export default component.exports